import { Tab, Tabs } from "@mui/material";
import { useContext } from "react";
import useLocales from "src/hooks/useLocales";

import Context from "../../context";
import useGetFundsFiltered from "./hooks/useGetFundsFiltered";

type Props = {
	onChangeTab: (event: React.SyntheticEvent<Element, Event>, newValue: any) => void;
	currentTab: string;
};

export default function FundsTab({ currentTab, onChangeTab }: Props) {
	const { theme, subproduct } = useContext(Context);
	const { translate } = useLocales();

	const { fundsAvailable, fundNotAvailable } = useGetFundsFiltered();

	const avaialablePositions = translate(
		`${subproduct === "FUND" ? "Fondos" : "Planes"} traspasables (${fundsAvailable.length})`
	);
	const notAvaialablePositions = translate(
		`${subproduct === "FUND" ? "Fondos" : "Planes"} NO traspasables (${fundNotAvailable.length})`
	);

	return (
		<Tabs
			allowScrollButtonsMobile
			onChange={onChangeTab}
			scrollButtons='auto'
			sx={{
				mt: 2,
				"& .MuiTab-root.Mui-selected": {
					color: theme?.colors.primary
				}
			}}
			TabIndicatorProps={{
				style: {
					backgroundColor: theme?.colors.primary
				}
			}}
			value={currentTab}
			variant='scrollable'
		>
			<Tab disableRipple label={avaialablePositions} value='available' />
			<Tab disableRipple label={notAvaialablePositions} value='not_available' />
		</Tabs>
	);
}
